import { render, staticRenderFns } from "./MbEdit.vue?vue&type=template&id=091eaf9f&"
import script from "./MbEdit.vue?vue&type=script&lang=js&"
export * from "./MbEdit.vue?vue&type=script&lang=js&"
import style0 from "./MbEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports